module.exports = __webpack_public_path__ + "src/assets/img/okkokontent.c4c096cd.jpg";